import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CalendarDays, Ticket } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { imgSrc } from "@/lib/categories";
import { longDate, to12 } from "@/lib/time";
import { Reviews } from "@/components/Reviews";

export default function ShowRecap() {
  const { rid } = useParams();
  const [recap, setRecap] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { api.get(`/recap/${rid}`).then((r) => setRecap(r.data)).catch((e) => setError(errorMessage(e))); }, [rid]);

  return (
    <main data-testid="show-recap-page" className="max-w-2xl mx-auto px-4 sm:px-6 py-10">
      <Link to="/notifications" data-testid="recap-back" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white">
        <ArrowLeft className="h-4 w-4" /> Alerts
      </Link>
      {error && <p data-testid="recap-error" className="mt-8 rounded-2xl border border-dashed border-[#26334D] p-10 text-center text-sm text-slate-400">{error}</p>}
      {recap && (
        <div className="rise">
          <div className="mt-6 relative overflow-hidden rounded-3xl border border-[#26334D] bg-[#151C2C]">
            {recap.listing.image_url && <img src={imgSrc(recap.listing.image_url)} alt="" className="h-48 w-full object-cover opacity-80" />}
            <div className="p-6">
              <p className="text-xs uppercase tracking-[0.2em] text-[#FF3B6B] font-semibold flex items-center gap-1.5"><Ticket className="h-3.5 w-3.5" /> Show recap</p>
              <h1 data-testid="recap-title" className="text-3xl sm:text-4xl font-extrabold tracking-tight mt-2">How was {recap.title}?</h1>
              <p data-testid="recap-when" className="text-sm text-slate-400 mt-2 flex items-center gap-1.5">
                <CalendarDays className="h-4 w-4" /> {longDate(`${recap.date}T12:00:00`)}{recap.time ? ` · ${to12(recap.time)}` : ""}{recap.city ? ` · ${recap.city}` : ""}
              </p>
              <p className="text-sm text-slate-300 mt-4">Tap the stars and add a photo. Your review shows on this show's listing so other travelers know what to expect.</p>
            </div>
          </div>
          <div className="mt-6 rounded-3xl border border-[#26334D] bg-[#151C2C] p-5">
            <Reviews item={recap.listing} city={recap.city} />
          </div>
        </div>
      )}
    </main>
  );
}
